app.controller('checksBalancesController', function ($rootScope, $scope, safeApply, checksBalancesService ) {

  init()

  async function init() {

    let results = await checksBalancesService.getHelloSignDocumentList()
    console.log('results :>> ', results);

  }

})